const l = `<svg width="56" height="57" viewBox="0 0 56 57" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <path
      d="M25.648 51.396c14.164 0 25.647-11.506 25.647-25.698C51.295 11.505 39.812 0 25.648 0 11.483 0 0 11.505 0 25.698 0 39.89 11.483 51.396 25.648 51.396zm0-17.522a2.917 2.917 0 012.914 2.92 2.917 2.917 0 01-2.914 2.92 2.917 2.917 0 01-2.915-2.92 2.917 2.917 0 012.915-2.92zm0-22.193a2.708 2.708 0 012.7 2.906l-1.137 15.498a1.568 1.568 0 01-3.127 0l-1.138-15.498a2.708 2.708 0 012.702-2.906z"
      id="alert-fill_a" />
  </defs>
  <g fill="none" fill-rule="evenodd">
    <path d="M0 1h56v56H0z" />
    <g transform="translate(2 3)">
      <mask id="alert-fill_b" fill="#fff">
        <use xlink:href="#alert-fill_a" />
      </mask>
      <use fill="currentColor" xlink:href="#alert-fill_a" />
      <path fill="currentColor" mask="url(#alert-fill_b)" d="M-2.332-2.336h55.958v56.068H-2.332z" />
    </g>
  </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=alert-fill.es-DwZ3lRLL.js.map
